import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../DataTable/DataTable"

class AmenityPresenterHistory extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'history',
      'tab-pane': true
    })
    return (
      <div className={tabClasses} id="history">
        <div className="row">
          <div className="col-md-12">
            <DataTable
              endpoint={this.props.amenity_revision_history_path}
              no_data_text={I18n.t('none')}
              currency_unit={I18n.t('number.currency.format.unit')}
              delimiter={I18n.t('number.currency.format.delimiter')}
              separator={I18n.t('number.currency.format.separator')}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              model_name={"Amenity"} />
          </div>
        </div>
      </div>  
    )
  }

}

export default AmenityPresenterHistory